import { render, staticRenderFns } from "./PriceControlDetail.vue?vue&type=template&id=f5db109a&scoped=true"
import script from "./PriceControlDetail.vue?vue&type=script&lang=js"
export * from "./PriceControlDetail.vue?vue&type=script&lang=js"
import style0 from "./PriceControlDetail.vue?vue&type=style&index=0&id=f5db109a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5db109a",
  null
  
)

export default component.exports